/**
 * todo: INSPIRE-8862: поменять хост для legacyAppPath.
 *
 * Primary path — без префикса `/rythm`. Пока балансер/беты ещё могут отдавать
 * старый pathname, принимаем `/rythm` на входе, но ссылки и canonical
 * генерируем только без него.
 */
export const LEGACY_APP_PATH_PREFIX = '/rythm';

export const isLegacyAppPath = (pathname: string): boolean =>
    pathname === LEGACY_APP_PATH_PREFIX || pathname.startsWith(`${LEGACY_APP_PATH_PREFIX}/`);

/** Снимает ведущий `/rythm` с pathname (query/hash не трогает). */
export const stripLegacyAppPath = (pathname: string): string => {
    if (!isLegacyAppPath(pathname)) {
        return pathname;
    }

    const stripped = pathname.slice(LEGACY_APP_PATH_PREFIX.length);

    return stripped.length === 0 ? '/' : stripped;
};

/**
 * Нормализует request path для роутинга: снимает primary basename и legacy `/rythm`.
 * Query string в path допускается (`/rythm/foo?x=1` → `/foo?x=1`).
 */
export const normalizeRequestPath = (requestPath: string): string => {
    const basePathname = process.env.REACT_APP_BASE_PATHNAME || '/';
    let path = requestPath;

    if (basePathname !== '/' && path.startsWith(basePathname)) {
        path = path.replace(new RegExp(`^${basePathname}/?`), '/');
    }

    const [pathname, querystring] = path.split('?');
    const normalizedPathname = stripLegacyAppPath(pathname);

    return querystring ? `${normalizedPathname}?${querystring}` : normalizedPathname;
};

/**
 * Basename для React Router: primary из env, либо legacy `/rythm`, если URL ещё на старом path.
 * Ссылки через buildRelativeUrl / REACT_APP_BASE_PATH всегда primary; basename только
 * чтобы router матчил текущий window/request path на время переезда.
 */
export const getRouterBasename = (pathname: string): string => {
    if (isLegacyAppPath(pathname)) {
        return LEGACY_APP_PATH_PREFIX;
    }

    return process.env.REACT_APP_BASE_PATHNAME || '/';
};

/** Префикс пути для текущего контура: `/rythm` в legacy-режиме, иначе ''. */
export const getAppPathPrefix = (pathname: string): string =>
    getRouterBasename(pathname).replace(/\/+$/, '');
